import ConversationState from "../controller/state/ConversationState";
import Conversation from "../model/Conversation";

export default class ConversationStateChangedEvent {
    /**
     * @constructor
     * @param {Conversation} conversation 
     * @param {ConversationState} state 
     */
    constructor(conversation, state) {
        this._type = ConversationStateChangedEvent.TYPE;

        this._conversation = conversation;
        this._state = state;
    }

    get type() {
        return this._type;
    }

    get conversation() {
        return this._conversation;
    }

    get state() {
        return this._state;
    }
}

ConversationStateChangedEvent.TYPE = "ConversationStateChangedEvent";